import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationWithIdRangeInput } from '../../../../types/schema/utils.types';
import { Transaction } from '../../../../types/schema/transaction.types';

interface GetAllTransactionsByUserIdByRangeByPageHook {
  data: Transaction[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllTransactionsByUserIdByRangeByPage: Transaction[];
    }>
  >;
}

interface UseGetAllTransactionsByUserIdByRangeByPageMutationData {
  getAllTransactionsByUserIdByRangeByPage: Transaction[];
}

interface UseGetAllTransactionsByUserIdByRangeByPageInputType {
  input: PaginationWithIdRangeInput;
}

export function useGetAllTransactionsByUserIdByRangeByPage(
  query: DocumentNode,
  input: PaginationWithIdRangeInput
): GetAllTransactionsByUserIdByRangeByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    UseGetAllTransactionsByUserIdByRangeByPageMutationData,
    UseGetAllTransactionsByUserIdByRangeByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllTransactionsByUserIdByRangeByPage,
    loading,
    error,
    refetch,
  };
}
